export const SURVEY_INVITE_STATUSES = [
  'SENT',
  'OPENED',
  'COMPLETED',
  'EXPIRED',
  'REVOKED',
] as const;
export type SurveyInviteStatus = (typeof SURVEY_INVITE_STATUSES)[number];

export const SURVEY_INVITE_ITEM_STATUSES = ['PENDING', 'IN_PROGRESS', 'SUBMITTED'] as const;
export type SurveyInviteItemStatus = (typeof SURVEY_INVITE_ITEM_STATUSES)[number];

export const SURVEY_RESPONDENT_ROLES = ['OWNER', 'MANAGER', 'STAFF', 'OTHER'] as const;
export type SurveyRespondentRole = (typeof SURVEY_RESPONDENT_ROLES)[number];

export const SURVEY_DEADLINE_MODES = ['NONE', 'SINGLE', 'RECURRING'] as const;
export type SurveyDeadlineMode = (typeof SURVEY_DEADLINE_MODES)[number];

/** Mesi di validità ammessi per SINGLE e RECURRING (CHECK del DB e DTO del template). */
export const SURVEY_DOCUMENT_VALIDITY_MONTHS_MIN = 1;
export const SURVEY_DOCUMENT_VALIDITY_MONTHS_MAX = 120;

/** Da dove viene la scadenza di un item di richiesta: dal template o scelta per questo cliente. */
export const SURVEY_INVITE_DEADLINE_SOURCES = ['TEMPLATE', 'CUSTOM'] as const;
export type SurveyInviteDeadlineSource = (typeof SURVEY_INVITE_DEADLINE_SOURCES)[number];

/** Esito del PDF di una response da invito, come lo vedono consulente e schermata finale. */
export type SurveyInvitePdfStatus = 'PENDING_PDF' | 'COMPLETED' | 'FAILED';

export function isSurveyRespondentRole(value: unknown): value is SurveyRespondentRole {
  return (
    typeof value === 'string' && (SURVEY_RESPONDENT_ROLES as readonly string[]).includes(value)
  );
}

export const SURVEY_INVITE_MAX_DAYS = 21;
export const SURVEY_INVITE_DEFAULT_DAYS = 14;
export const SURVEY_INVITE_MAX_TEMPLATES = 10;
export const SURVEY_INVITE_REMINDER_MIN_HOURS = 24;
export const SURVEY_INVITE_SESSION_HEADER = 'x-survey-invite-token';
/** Due aperture entro questa finestra contano una volta sola (il JWT si rinnova ogni ora). */
export const SURVEY_INVITE_OPEN_DEBOUNCE_MINUTES = 30;
/** Inviti creabili da un consulente in 24 ore: la piattaforma non è un relay email. */
export const SURVEY_INVITE_DAILY_CREATE_LIMIT = 100;
/** Token in chiaro: 64 hex oggi, margine per una codifica base64url futura. */
export const SURVEY_INVITE_TOKEN_MAX_LENGTH = 128;

export const SURVEY_INVITE_ID_MAX_LENGTH = 64;
export const SURVEY_INVITE_EMAIL_MAX_LENGTH = 254;
export const SURVEY_INVITE_RECIPIENT_NAME_MAX_LENGTH = 120;
export const SURVEY_INVITE_MESSAGE_MAX_LENGTH = 500;
export const SURVEY_INVITE_REVOKE_REASON_MAX_LENGTH = 300;
export const SURVEY_INVITE_SEARCH_MAX_LENGTH = 120;
export const SURVEY_INVITE_LIST_DEFAULT_PAGE_SIZE = 20;
export const SURVEY_INVITE_LIST_MAX_PAGE_SIZE = 50;
export const SURVEY_RESPONDENT_NAME_MAX_LENGTH = 120;
export const SURVEY_RESPONDENT_ROLE_OTHER_MAX_LENGTH = 80;
export const SURVEY_INVITE_NODE_ID_MAX_LENGTH = 128;
